// src/components/pages/PrivacyPolicy.js

import React from 'react';
import LegalPage from './LegalPage';

export default function PrivacyPolicy() {
    return (
        <div>
            <LegalPage pageType="privacy_policy" />
        </div>
    );
}
